module.exports = __webpack_public_path__ + "25868309a586fba317f3add4f2e803f0.svg";